import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import {requestPassword} from '../core/_requests'
import { ToastContainer } from 'react-toastify'
import { error } from 'console'
import { fetchData, toasterrormsg, toastsuccessmsg } from '../../../../reusable'
import { Tr } from '../../../../_metronic/i18n/Tr'

export function ResetPassword() {

  const t = Tr();
  const navigate=useNavigate()
  const [loading, setLoading] = useState(false)
  const [indicatorStatus,setIndicatorStatus]=useState("0")
  const [password,setPassword]=useState("")
  const [confirmPassword,setConfirmPassword]=useState("")
  const [OTP,setOTP]=useState("")
  const [errorMessage,setErrorMessage]=useState({"otp":"","password":"","confirmPassword":""})
  const [submited,setSubmited]=useState(false)

  const checkindicator=(value:any)=>{
    var num=0;

    if(value.length>=6)
    {
      num+=1
    }

    if((/[a-z]/.test(value)))
    {
      num+=1
    }

    if((/[A-Z]/.test(value)))
    {
      num+=1
    }

    if((/[0-9]/.test(value)))
    {
      num+=1
    }

    if((/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value)))
    {
      num+=1
    }

    setIndicatorStatus(String(num))
  }

  const validator=(otp:any,pass:any,confirmPass:any,submi:any,finalSubmit:any=false)=>{
    var tmpvali:any=errorMessage
    if(submi==true)
    {
      if(otp=="" || otp==null || otp==undefined)
      {
        tmpvali['otp']=t("OTP Required")
      }
      else if(otp.length!=4)
      {
        tmpvali['otp']=t("Enter Valid OTP")
      }
      else
      {
        tmpvali['otp']=""
      }
      if(pass==="" || pass===null || pass===undefined)
      {
        tmpvali['password']=t("Password Required")
      }
      else if(pass.length<6)
      {
        tmpvali['password']=t("Enter At Least 6 Digit Password")
      }
      else
      {
        tmpvali['password']=""
      }
      if(confirmPass==="" || confirmPass===null || confirmPass===undefined)
      {
        tmpvali['confirmPassword']=t("Confirm Password is required")
      }
      else if(pass!=confirmPass)
      {
        tmpvali['confirmPassword']=t("Password and Confirm Password are not matched")
      }
      else
      {
        tmpvali['confirmPassword']=""
      }

      if( tmpvali['otp']=="" &&  tmpvali['password']=="" &&  tmpvali['confirmPassword']=="" && finalSubmit==true)
      {
        resetpasswordapicall()
      }
    }

  }

  const resetpasswordapicall=async()=>{
    var vendorId = localStorage.getItem("vendorId");
    if(vendorId!=="" || vendorId!==null || vendorId!=undefined)
    {
      var param:any={
        vendorId:vendorId,
        newPassword:password,
        confirmPassword:confirmPassword,
        otp:OTP
      }
      var response:any=await fetchData("public/resetpassword",param)
      
      if(response.status=="200")
      {
        localStorage.removeItem("resetEmail")
        toastsuccessmsg(t("Password Reset Successfully"))

        setTimeout(() => {
          navigate("../");
        }, 1500);
        
      }
      else
      {
        // setSubmitting(false)
        toasterrormsg(response.message)
        setLoading(false)
      }
    }
  }

  return (
    <>
    
    <ToastContainer />

      <div
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        id='kt_login_password_reset_form'
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark fw-bolder mb-3'>{t('Setup New Password')}</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-500 fw-semibold fs-6'>
          {t('Have you already reset the password ?')} <a href="../">{t('Sign in')}</a>
          </div>
          {/* end::Link */}
        </div>

        

        {/* begin::Form group */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>{t('OTP')}</label>
          <input
            type='text'
            placeholder={t('OTP')}
            autoComplete='off'
            className={'form-control bg-transparent'}
            value={OTP}
            onChange={(e:any)=>{setOTP(e.target.value);validator(e.target.value,password,confirmPassword,submited)}}
          />
          {
            errorMessage['otp']!=="" && <span className='text-danger mt-3'>{errorMessage['otp']}</span>
          }
        
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>{t('Password')}</label>
          <input
            type='password'
            placeholder={t('Password')}
            autoComplete='off'
            className={'form-control bg-transparent'}
            value={password}
            onChange={(e:any)=>{setPassword(e.target.value);checkindicator(e.target.value);validator(OTP,e.target.value,confirmPassword,submited)}}
          />
        
        {
          errorMessage['password']!=="" && <span className='text-danger'>{errorMessage['password']}</span>
        }
        </div>
        {/* end::Form group */}
        {/* <!--begin::Meter--> */}
        <div className="d-flex align-items-center mb-3" data-kt-password-meter-control="highlight">
          <div className={`flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2 ${indicatorStatus>"1"?"active":""}`}></div>
          <div className={`flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2 ${indicatorStatus>"2"?"active":""}`}></div>
          <div className={`flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2 ${indicatorStatus>"3"?"active":""}`}></div>
          <div className={`flex-grow-1 bg-secondary bg-active-success rounded h-5px ${indicatorStatus>"4"?"active":""}`}></div>
        </div>
        {/* <!--end::Meter--> */}

        {/* begin::Form group */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>{t('Confirm Password')}</label>
          <input
            type='password'
            placeholder={t('Confirm Password')}
            autoComplete='off'
            className={'form-control bg-transparent'}
            value={confirmPassword}
            onChange={(e:any)=>{setConfirmPassword(e.target.value);validator(OTP,password,e.target.value,submited)}}
          />
        
        {
          errorMessage['confirmPassword']!=="" && <span className='text-danger mt-1 mb-3'>{errorMessage['confirmPassword']}</span>
        }
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button type='button' id='kt_password_reset_submit' className='btn btn-primary me-4' onClick={()=>{setSubmited(true);validator(OTP,password,confirmPassword,true,true)}}>
            <span className='indicator-label'>{t('Submit')}</span>
            {loading && (
              <span className='indicator-progress'>
                {t('Please wait...')}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          {' '}
        </div>
        {/* end::Form group */}
      </div>
    </>
  )
}
